export default "__VITE_ASSET__DVpD$qm3__"